module.exports = __webpack_public_path__ + "static/media/lateralhead_mild_left.ba8b1f0a.png";